// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IParticipantEmploymentInfoDto
 */
export interface IParticipantEmploymentInfoDto {
    /**
     * Required if organization idSource is EID
     * @type {string}
     * @memberof IParticipantEmploymentInfoDto
     */
    employer_employee_id?: string;
    /**
     * Required if organization idSource is PID
     * @type {string}
     * @memberof IParticipantEmploymentInfoDto
     */
    partner_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantEmploymentInfoDto
     */
    employment_status: IParticipantEmploymentInfoDtoEmploymentStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof IParticipantEmploymentInfoDto
     */
    employment_status_effective_on: Date;
}

/**
* @export
* @enum {string}
*/
export enum IParticipantEmploymentInfoDtoEmploymentStatusEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}


/**
 * Check if a given object implements the IParticipantEmploymentInfoDto interface.
 */
export function instanceOfIParticipantEmploymentInfoDto(value: object): value is IParticipantEmploymentInfoDto {
    if (!('employment_status' in value) || value['employment_status'] === undefined) return false;
    if (!('employment_status_effective_on' in value) || value['employment_status_effective_on'] === undefined) return false;
    return true;
}

export function IParticipantEmploymentInfoDtoFromJSON(json: any): IParticipantEmploymentInfoDto {
    return IParticipantEmploymentInfoDtoFromJSONTyped(json, false);
}

export function IParticipantEmploymentInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IParticipantEmploymentInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employer_employee_id': json['employer_employee_id'] == null ? undefined : json['employer_employee_id'],
        'partner_employee_id': json['partner_employee_id'] == null ? undefined : json['partner_employee_id'],
        'employment_status': json['employment_status'],
        'employment_status_effective_on': (new Date(json['employment_status_effective_on'])),
    };
}

export function IParticipantEmploymentInfoDtoToJSON(json: any): IParticipantEmploymentInfoDto {
    return IParticipantEmploymentInfoDtoToJSONTyped(json, false);
}

export function IParticipantEmploymentInfoDtoToJSONTyped(value?: IParticipantEmploymentInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employer_employee_id': value['employer_employee_id'],
        'partner_employee_id': value['partner_employee_id'],
        'employment_status': value['employment_status'],
        'employment_status_effective_on': ((value['employment_status_effective_on']).toISOString()),
    };
}

